// extracted by mini-css-extract-plugin
export var activeDot = "_2u-c";
export var buttonContainer = "_2u-9";
export var channelButton = "_2u-a";
export var clickable = "_2u-d";
export var content = "_2u-0";
export var contentFull = "_2u-2";
export var contentThird = "_2u-1";
export var contentWrapper = "_2u-7";
export var description = "_2u-5";
export var heightShort = "_2u-f";
export var image = "_2u-3";
export var imageContainer = "_2u-4";
export var selectButton = "_2u-e";
export var spinnerContainer = "_2u-b";
export var titleContent = "_2u-8";
export var titleWrapper = "_2u-6";